module.exports = __webpack_public_path__ + "img/1507624025.a8bf5734.jpg";